import { useState, useEffect } from 'react';
import { ButtonSubmit } from '../ButtonSubmit';
import {
  CONST_GENDER_FEMALE,
  CONST_GENDER_MALE,
  isValidGender,
  getBirthdayInFormat,
  getDate,
  getMonths,
  getYears,
  validateAge,
  simplyClick,
} from '../../helpers';
import './FirtsStep.scss';
import Logo from '../../images/logo.svg';
import logoMobile from '../../images/logo__mobile.svg';

export const FirtsStep = ({ data, setData, nextStep }) => {
  const [errorGender, setErrorGender] = useState(null);
  const [errorDate, setErrorDate] = useState(null);
  const [birthdayData, setBirthdayData] = useState({});
  const [loginUrl, setLoginUrl] = useState('/login/');
  const [choiceGender, setChoiceGender] = useState(CONST_GENDER_MALE);
  const [choiceLookingGender, setChoiceLookingGender] =
    useState(CONST_GENDER_FEMALE);

  useEffect(() => {
    setData({ ...data, gender: CONST_GENDER_MALE });

    if (window.location.search !== '') {
      setLoginUrl(`/login/${window.location.search}`);
    }
  }, []);

  const handlerSubmit = (e) => {
    e.preventDefault();

    const { error, status } = validateAge(
      birthdayData.month,
      birthdayData.day,
      birthdayData.year,
    );
    if (!isValidGender(data.gender)) {
      setErrorGender('Please,choose your gender.');
      return;
    } else if (!status) {
      setErrorDate(error);
      return;
    }
    setData({
      ...data,
      birthday: getBirthdayInFormat(
        birthdayData.year,
        birthdayData.month,
        birthdayData.day,
      ),
    });
    nextStep();
  };

  const handleAddTypeGender = (e) => {
    setData({ ...data, gender: +e.target.value });

    if (+e.target.value === CONST_GENDER_MALE) {
      setChoiceGender(CONST_GENDER_MALE);
      setChoiceLookingGender(CONST_GENDER_FEMALE);
    }
    if (+e.target.value === CONST_GENDER_FEMALE) {
      setChoiceGender(CONST_GENDER_FEMALE);
      setChoiceLookingGender(CONST_GENDER_MALE);
    }
  };

  const handleAddLookingGender = (e) => {
    if (+e.target.value === CONST_GENDER_FEMALE) {
      setChoiceGender(CONST_GENDER_MALE);
      setChoiceLookingGender(CONST_GENDER_FEMALE);
      setData({ ...data, gender: CONST_GENDER_MALE });
    }
    if (+e.target.value === CONST_GENDER_MALE) {
      setChoiceGender(CONST_GENDER_FEMALE);
      setChoiceLookingGender(CONST_GENDER_MALE);
      setData({ ...data, gender: CONST_GENDER_FEMALE });
    }
  };
  const handleAddMonth = (e) => {
    setErrorDate(null);
    setBirthdayData({ ...birthdayData, month: e.target.value });
  };
  const handleAddDay = (e) => {
    setErrorDate(null);
    setBirthdayData({ ...birthdayData, day: e.target.value });
  };
  const handleAddYear = (e) => {
    setErrorDate(null);
    setBirthdayData({ ...birthdayData, year: e.target.value });
  };

  return (
    <>
      <main className="main">
        <div className="main__first">
          <div className="main__wrapper">
            <header className="header__mobile">
              <img className="logo logo__mobile" src={logoMobile} alt="logo" />
              <div
                className="sign__in-mobile"
                onClick={() => simplyClick('cl_lnd_qm1_main_sign', null, false)}
              >
                <a href={loginUrl}>Sign in</a>
              </div>
            </header>

            <form
              className="first__step-form first__step-form-mobile"
              onSubmit={handlerSubmit}
            >
              <img className="logo" src={Logo} alt="logo" />
              <h1 className="title">Find Your Slavic Soulmate</h1>
              <p className="text">
                Connecting verified singles across the globe
              </p>
              <div className="gender__wrapper">
                <div className="gender__choose-box">
                  <span className="span">I am:</span>
                  <div className="gender__choose">
                    <label>
                      <input
                        className="gender__man"
                        type="radio"
                        name="man"
                        value={CONST_GENDER_MALE}
                        checked={choiceGender === CONST_GENDER_MALE}
                        onChange={(e) => handleAddTypeGender(e)}
                      />
                      <div className="form__gender-male">
                        <span>a man</span>
                      </div>
                    </label>
                    <label>
                      <input
                        className="gender__female"
                        type="radio"
                        name="man"
                        checked={choiceGender === CONST_GENDER_FEMALE}
                        value={CONST_GENDER_FEMALE}
                        onChange={(e) => handleAddTypeGender(e)}
                      />
                      <div className="form__gender-female">
                        <span>a woman</span>
                      </div>
                    </label>
                  </div>
                  {errorGender && <p className="error-text">{errorGender}</p>}
                </div>
                <div className="gender__loking-box">
                  <span className="span">looking for:</span>
                  <div className="gender__looking">
                    <label>
                      <input
                        className="gender__female"
                        type="radio"
                        name="woman"
                        value={CONST_GENDER_FEMALE}
                        // defaultChecked
                        checked={choiceLookingGender === CONST_GENDER_FEMALE}
                        onChange={(e) => handleAddLookingGender(e)}
                      />
                      <div className="form__gender-female">
                        <span>a woman</span>
                      </div>
                    </label>
                    <label>
                      <input
                        className="gender__male"
                        type="radio"
                        name="woman"
                        value={CONST_GENDER_MALE}
                        checked={choiceLookingGender === CONST_GENDER_MALE}
                        onChange={(e) => handleAddLookingGender(e)}
                      />
                      <div className="form__gender-male">
                        <span>a man</span>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              <div className="date__wrapper">
                <span>My date of birth:</span>
                <div className="date__wrapper-box">
                  <div className="date__wrapper-select">
                    <select
                      className={birthdayData.month ? 'active' : ''}
                      onChange={(e) => handleAddMonth(e)}
                      defaultValue="default"
                    >
                      <option value="default" disabled hidden>
                        Month
                      </option>
                      {getMonths().map((item, index) => (
                        <option key={index} value={index}>
                          {item || ''}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="date__wrapper-select">
                    <select
                      className={birthdayData.day ? 'active' : ''}
                      onChange={(e) => handleAddDay(e)}
                      defaultValue="default"
                    >
                      <option value="default" disabled hidden>
                        Day
                      </option>
                      {getDate().map((item, index) => (
                        <option key={index} value={item}>
                          {item || ''}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="date__wrapper-select">
                    <select
                      className={birthdayData.year ? 'active' : ''}
                      onChange={(e) => handleAddYear(e)}
                      defaultValue="default"
                    >
                      <option value="default" disabled hidden>
                        Year
                      </option>
                      {getYears().map((item, index) => (
                        <option key={index} value={item}>
                          {item || ''}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {errorDate && <p className="error-text">{errorDate}</p>}
              </div>
              <p className="form__date-text">
                By proceeding you confirm that you are fully legally capable of
                using website and major or at least 18 years old
              </p>
              <ButtonSubmit
                className={'button__global first__button'}
                text={'Join now'}
                dataAttr={'cookies'}
                onClick={() => simplyClick('cl_lnd_qm1_main_join', null, false)}
              />
            </form>

            <div
              className="sign__in"
              onClick={() => simplyClick('cl_lnd_qm1_main_sign', null, false)}
            >
              <a href={loginUrl}>Sign in</a>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};
